import styled from "styled-components"
import { Text } from "componentsStyled/Typography"

export const OpeningHoursTableWrap = styled.div`
  margin-bottom: 3rem;
`

export const Pair = styled.div`
  display: flex;
`

export const Key = styled(Text)`
  width: 11rem;
  text-transform: capitalize;
`

export const Val = styled(Text)`
  flex-grow: 1;
`



// WEBPACK FOOTER //
// ./src/pages/Affiliate/Content/Info/OpeningHoursTable/styled.js